// extracted by mini-css-extract-plugin
export default {"bannerComponent":"Sk-z","red":"Tk-z","calloutlink":"Uk-z","headerTopBanner":"Vk-z","bgcolorRed":"Wk-z","headerTopCallout":"Xk-z","searchBanner":"Yk-z","hideMobile":"Zk-z"};